import React, { useState } from 'react';
import {
  Page,
  Layout,
  Card,
  FormLayout,
  TextField,
  Select,
  Button,
  TextContainer,
  Heading,
  Text,
  Banner,
  Link
} from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

const ContactUs = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    subject: 'general',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (field) => (value) => {
    setFormState({ ...formState, [field]: value });
  };

  const handleSubmit = () => {
    // Basic validation
    if (!formState.name || !formState.email || !formState.message) {
      setError(true);
      return;
    }

    // In a real application, you would send this data to your backend
    // For now, we'll just simulate a successful submission
    setTimeout(() => {
      setSubmitted(true);
      setError(false);
      // Reset form
      setFormState({
        name: '',
        email: '',
        subject: 'general',
        message: ''
      });
    }, 1000);
  };

  const subjectOptions = [
    { label: 'General Inquiry', value: 'general' },
    { label: 'Technical Support', value: 'support' },
    { label: 'Billing Question', value: 'billing' },
    { label: 'Feature Request', value: 'feature' },
    { label: 'Report a Bug', value: 'bug' },
    { label: 'Partnership Opportunity', value: 'partnership' }
  ];

  return (
    <AppProvider i18n={enTranslations}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <div style={{ marginBottom: '20px' }}>
          <Link url="/">← Back to Home</Link>
        </div>
        
        <Layout>
          <Layout.Section>
            {submitted && (
              <Banner
                title="Message Sent"
                status="success"
                onDismiss={() => setSubmitted(false)}
              >
                <p>Thank you for contacting us. We'll respond to your inquiry as soon as possible.</p>
              </Banner>
            )}

            {error && (
              <Banner
                title="Error"
                status="critical"
                onDismiss={() => setError(false)}
              >
                <p>Please fill out all required fields.</p>
              </Banner>
            )}

            <Card sectioned>
              <TextContainer>
                <Heading>Get in Touch</Heading>
                <Text>We'd love to hear from you! Please fill out the form below and we'll get back to you as soon as possible.</Text>
              </TextContainer>
              
              <FormLayout>
                <TextField
                  label="Name"
                  value={formState.name}
                  onChange={handleChange('name')}
                  autoComplete="name"
                  requiredIndicator
                />
                
                <TextField
                  label="Email"
                  value={formState.email}
                  onChange={handleChange('email')}
                  type="email"
                  autoComplete="email"
                  requiredIndicator
                />
                
                <Select
                  label="Subject"
                  options={subjectOptions}
                  value={formState.subject}
                  onChange={handleChange('subject')}
                />
                
                <TextField
                  label="Message"
                  value={formState.message}
                  onChange={handleChange('message')}
                  multiline={4}
                  requiredIndicator
                />
                
                <Button primary onClick={handleSubmit}>Send Message</Button>
              </FormLayout>
            </Card>
          </Layout.Section>
          
          <Layout.Section secondary>
            <Card sectioned>
              <TextContainer>
                <Heading>Contact Information</Heading>
                <Text>You can also reach us using the following contact information:</Text>
                
                <Heading element="h3">Email</Heading>
                <Text>support@elevia-solutions.com</Text>
                <Text>sales@elevia-solutions.com</Text>
                
                <Heading element="h3">Address</Heading>
                <Text>Elevia Solutions FZ-LLC</Text>
                <Text>Compass Building, Al Shohada Road</Text>
                <Text>Ras Al Khaimah, FDRK7068</Text>
                <Text>United Arab Emirates</Text>
                
                <Heading element="h3">Business Hours</Heading>
                <Text>Monday - Friday: 9:00 AM - 5:00 PM (PST)</Text>
                <Text>Saturday - Sunday: Closed</Text>
              </TextContainer>
            </Card>
            
            <Card sectioned>
              <TextContainer>
                <Heading>Frequently Asked Questions</Heading>
                <Heading element="h3">How quickly will I receive a response?</Heading>
                <Text>We typically respond to all inquiries within 24-48 business hours.</Text>
                
                <Heading element="h3">Do you offer phone support?</Heading>
                <Text>Phone support is available for Premium plan subscribers. Please include your account details in your message if you'd like a callback.</Text>
                
                <Heading element="h3">I'm having technical issues. What information should I provide?</Heading>
                <Text>Please include your Shopify store URL, subscription plan, browser type and version, and a detailed description of the issue you're experiencing.</Text>
              </TextContainer>
            </Card>
          </Layout.Section>
        </Layout>
      </div>
    </AppProvider>
  );
};

export default ContactUs;
